import {
  FormControl,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import KeyboardArrowDownRounded from "@mui/icons-material/KeyboardArrowDownRounded";
import { colors } from "../constants/designTokens";

export default function FilterSelect({
  value,
  onChange,
  options,
  placeholder,
  icon: Icon,
  minWidth = 240,
  height = 40,
  borderRadius = 2.5,
  disabled = false,
}) {
  return (
    <FormControl
      size="small"
      sx={{
        minWidth,
        "& .MuiOutlinedInput-root": {
          height,
          borderRadius,
          bgcolor: colors.surface,
          boxShadow: "0 6px 16px rgba(23, 39, 70, 0.06)",
          "& fieldset": { borderColor: colors.border },
          "&:hover fieldset": { borderColor: "#cbd7e7" },
        },
      }}
      disabled={disabled}
    >
      <Select
        value={value ?? ""}
        onChange={(event) => onChange(event.target.value)}
        displayEmpty
        IconComponent={KeyboardArrowDownRounded}
        renderValue={(selected) => {
          if (!selected) {
            return (
              <span style={{ color: colors.softMuted }}>
                {placeholder || ""}
              </span>
            );
          }

          const option = options.find((item) => item.value === selected);
          return option?.label || selected;
        }}
      >
        {placeholder ? (
          <MenuItem value="">
            <ListItemText>{placeholder}</ListItemText>
          </MenuItem>
        ) : null}
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {Icon ? (
              <ListItemIcon sx={{ minWidth: 30 }}>
                <Icon sx={{ fontSize: 18, color: colors.muted }} />
              </ListItemIcon>
            ) : null}
            <ListItemText>{option.label}</ListItemText>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
